export const academicsIntro = 'King Edwards Academy offers both the Cambridge International and the ZIMSEC ' +
  'curricula from Form 1 to Form 6. Learners are prepared for global success while keeping a strong pride in ' +
  'our national heritage, and every subject is taught by qualified, specialist staff.'

export const curricula = [
  {
    id: 1,
    name: 'Cambridge International',
    levels: 'Cambridge Lower Secondary, IGCSE and AS & A Level',
    subjects: [
      'English Language and English Literature',
      'Mathematics and Additional Mathematics',
      'Biology, Chemistry and Physics',
      'Combined and Co-ordinated Sciences',
      'Geography and History',
      'Business Studies, Economics and Accounting',
      'Computer Science and Information Technology',
      'Design and Technology',
      'Art and Design',
      'Physical Education'
    ]
  },
  {
    id: 2,
    name: 'ZIMSEC',
    levels: 'Ordinary Level (Form 1 - 4) and Advanced Level (Form 5 - 6)',
    subjects: [
      'English Language and Literature in English',
      'Mathematics and Pure Mathematics',
      'Biology, Chemistry and Physics',
      'Combined Science',
      'Geography and History',
      'Principles of Accounts, Business Enterprise Skills and Economics',
      'Computer Science and Information Technology',
      'Agriculture',
      'Shona',
      'Family and Religious Studies',
      'Heritage Studies',
      'Physical Education, Sport and Mass Displays'
    ]
  }
]

export const academicStrengths = [
  {
    id: 1,
    title: 'Remediation Programme',
    desc: 'Learners who need extra ground work are identified early and given structured, small group support ' +
      'until they are back on track. No learner is left to fall behind quietly.'
  },
  {
    id: 2,
    title: 'Extension Programme',
    desc: 'High achieving learners are stretched beyond the syllabus with advanced work, olympiads and ' +
      'independent research projects that prepare them for competitive university entry.'
  },
  {
    id: 3,
    title: 'Strong Emphasis on Practical Subjects',
    desc: 'Well equipped laboratories, computer suites and workshops mean science, technology and design are ' +
      'taught through hands-on practical work, not theory alone.'
  },
  {
    id: 4,
    title: 'International University Pathways',
    desc: 'Our local and international affiliations, particularly with top universities in the United Kingdom, ' +
      'give our learners a real advantage when applying to study abroad.'
  }
]
